import { ArcClaimDto } from './model.dto'
import { ObjectType } from '@nestjs/graphql'
import PaginatedResponse from '../../base/paginatedResponse'

@ObjectType()
export class ArcClaimPagedResultDto extends PaginatedResponse(ArcClaimDto) {
}
